const toggleSubAll = (_state, { allowSub }) => ({
  event: allowSub ? 'global_substitution_selector_ticked' : 'global_substitution_selector_unticked',
});

export default toggleSubAll;
